import RecurringBaseLayout from '../../Component/Recurring/RecurringBaseLayout'
import SearchPayments, { RecurringFormData } from '../../Component/Recurring/SearchPayments'
import React, { useContext, useState } from 'react'
import DisplayPayments from '../../Component/Recurring/DisplayPayments'
import { AppCtx } from '@paytrace/pt-skel/Context'

function ViewPayments () {
  const context = useContext(AppCtx)
  const merchant_id = context.merchant
  const [currentPage, setCurrentPage] = useState(0)
  const [formData, setFormData] = React.useState<RecurringFormData>({
    merchant_id,
    customerProfile: '',
    frequency: '',
    status: '',
    searchableText: '',
    dateRange: { startDate: new Date(), endDate: new Date() },
  })

  return (
    <RecurringBaseLayout
      title={'View Payments'}
      helpLink="https://paytrace.atlassian.net/wiki/spaces/HD/pages/2027487634/New+Payment"
    >
        <SearchPayments formData={formData} setFormData={setFormData} currentPage={currentPage} setCurrentPage={setCurrentPage} />
        <DisplayPayments formData={formData} currentPage={currentPage} setCurrentPage={setCurrentPage} />
    </RecurringBaseLayout>
  )
}

export default ViewPayments
